import React from 'react';
import styles from './h1.module.scss';
const H1 = ({ children }) => <h1 className={styles.h1}>{children}</h1>;
export default H1;



// WEBPACK FOOTER //
// ./src/components/h1/h1.js